import { Typography } from '@mui/joy';
import { Circle } from '@phosphor-icons/react';

import { getLabel } from 'core/utils';
import { theme } from 'theme';
import { Color, Level } from 'theme/enums';
import { IColorMap } from 'theme/types';

interface IProps {
  value: string;
  labelMap?: Record<string, string>;
  colorMap: IColorMap;
}

const Status = ({ value, labelMap, colorMap }: IProps) => {
  return (
    <Typography
      level={Level.TITLE_SM}
      color={colorMap[value]}
      startDecorator={<Circle weight="fill" style={{ fontSize: 10 }} />}
      sx={{
        ...(Color.NEUTRAL === colorMap[value]
          ? { color: `rgba(${theme.palette.neutral.mainChannel} / 1) !important` }
          : {}),
        fontWeight: 600,
        textWrap: 'balance',
      }}
    >
      {labelMap?.[value] || getLabel(value)}
    </Typography>
  );
};

export default Status;
